import React from 'react';
import './index.scss';
import { Link } from 'react-router-dom';
import {globe} from '../../assets/cloudinaryUrls';
import { FormattedMessage } from 'react-intl';
import LanguageSwitcher from '../LanguageSwitcher';

function Footer() {
  return (
    <div className='footer'>
    <div className='footer-block flex-row'>
      <div className='left-div flex-clmn'>
        <div className='logo'>
          <h5>Casas Campos</h5>
        </div>
        <div className='lang flex-row'>
          <img src={globe} alt='globe' className='icon' />
         <LanguageSwitcher/>
        </div>
      </div>
      <div className='centered-div flex-row'>
        <div className='f-clmn flex-clmn'>
          <p><FormattedMessage id="footer.discover" /></p>
          <Link to="/buyers#how-it-work" className='footer-link'><FormattedMessage id="footer.howItWorks" /></Link>
          {/* <Link to="#" className='footer-link'>Our properties</Link> */}
          <Link to="/owners" className='footer-link'><FormattedMessage id="footer.owners" /></Link>
          <Link to="/buyers" className='footer-link'><FormattedMessage id="footer.buyHouse" /></Link>
        </div>
        <div className='f-clmn flex-clmn'>
          <p><FormattedMessage id="footer.getInformed" /></p>
          <Link to="#" className='footer-link'><FormattedMessage id="footer.careers" /></Link>
          <Link to="#" className='footer-link'><FormattedMessage id="footer.privacyPolicy" /></Link>
          <Link to="#" className='footer-link'><FormattedMessage id="footer.manageCookies" /></Link>
          <Link to="#" className='footer-link'><FormattedMessage id="footer.termsOfUse" /></Link>
          <Link to="#" className='footer-link'><FormattedMessage id="footer.faq" /></Link>
          <Link to="#" className='footer-link'><FormattedMessage id="footer.contactUs" /></Link>
        </div>
      </div>
      <div className='right-div flex-clmn'>
        <h5><FormattedMessage id="footer.haveQuestion" /></h5>
        <div className='line'></div>
        <p><FormattedMessage id="footer.leaveNumber" /></p>
        <div className='input flex-row'>
          <input type="text" id="get-called"></input>
          <button className='prop-btn anim-btn'><FormattedMessage id="footer.getCalled" /></button>
        </div>
      </div>
    </div>
  </div>
  )
}

export default Footer